/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VertialSplit from "./../../../Basis/Components/VerticalSplit";
const BelegeView = React.lazy(() => import(/* webpackChunkName: "Belege" */"../Views/BelegeView"));
const BelegpositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegpositionenNavigationView"));
const BelegpositionView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegpositionView"));
const BelegeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegeBreadcrumb"));
const BelegBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegBreadcrumb"));
const BelegEmpfaengeradresseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegEmpfaengeradresseBreadcrumb"));
const BelegTexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegTexteBreadcrumb"));
const BelegpositionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegpositionenBreadcrumb"));
const BelegdruckBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegdruckBreadcrumb"));
const BelegpositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "./../Components/BelegpositionBreadcrumb"));
const NummernkreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/NummernkreiseBreadcrumb"));
const NummernkreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/NummernkreisBreadcrumb"));
const BelegView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegView"));
const BelegeNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegeNavigationView"));
const BelegpositionViewRedirect = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegpositionViewRedirect"));
const BelegdruckView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegdruckView"));
const BelegpositionDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegpositionDetailsView"));
const BelegDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegDetailsView"));
const BelegEmpfaengeradresseView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegEmpfaengeradresseView"));
const BelegTexteView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegTexteView"));
const BelegpositionenView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegpositionenView"));
const NummernkreiseView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/NummernkreiseView"));
const NummernkreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/NummernkreiseNavigationView"));
const NummernkreisView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/NummernkreisView"));
const NummernkreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/NummernkreisDetailsView"));
const StornobedingungDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungDefinitionenView"));
const StornobedingungDefinitionView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungDefinitionView"));
const StornobedingungDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungDefinitionenNavigationView"));
const StornobedingungDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungDefinitionDetailsView"));
const StornobedingungDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/StornobedingungDefinitionenBreadcrumb"));
const StornobedingungDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/StornobedingungDefinitionBreadcrumb"));
const StornobedingungenView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungenView"));
const StornobedingungView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungView"));
const StornobedingungenNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungenNavigationView"));
const StornobedingungDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/StornobedingungDetailsView"));
const StornobedingungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/StornobedingungenBreadcrumb"));
const StornobedingungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/StornobedingungBreadcrumb"));
const FibuExporteView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExporteView"));
const FibuExporteNavigationView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExporteNavigationView"));
const FibuExportView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExportView"));
const FibuExportDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExportDetailsView"));
const FibuExporteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/FibuExporteBreadcrumb"));
const FibuExportBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/FibuExportBreadcrumb"));
const BelegdruckSupportView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/BelegdruckSupportView"));
const AnfechtungViewRedirect = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/AnfechtungViewRedirect"));
const ZahlungenView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/ZahlungenView"));
const ZahlungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/ZahlungenBreadcrumb"));
const FibuExportDownloadRedirect = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/FibuExportDownloadRedirect"));
const FibuExportEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExportEinstellungenDetailsView"));
const FibuExportEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Components/FibuExportEinstellungenBreadcrumb"));
const FibuExportEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Belege" */ "../Views/FibuExportEinstellungenView"));

const BELEGEPATH = "/belege";
const BELEGPATH = "/beleg/:belegId";
const BELEGPOSITIONPATH = "/beleg/:belegId/belegposition/:belegpositionId";
const NUMMERNKREISPATH = "/nummernkreis/:nummernkreisId";
const FIBUEXPORTPATH = "/fibuexport/:fibuExportId";
const STORNOBEDINGUNGDEFINITIONPATH = "/stornobedingung/:stornobedingungDefinitionId";
const STORNOBEDINGUNGPATH = "/stornobedingung/:stornobedingungDefinitionId/bedingung/:stornobedingungId";

export function createBelegeRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [{
        exact: true,
        path: safePathPrefix + BELEGEPATH,
        parentPath: pathPrefix,
        render: (renderProps) => <BelegeView {...renderProps} legeBelegAnErlaubt />,
        createBreadcrumbs: (createProps: any) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />],
    },
    {
        path: safePathPrefix + BELEGPOSITIONPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <BelegpositionView {...renderProps} />}
                left={() => <BelegpositionenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegpositionenBreadcrumb {...createProps} />,
            <BelegpositionBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: safePathPrefix + BELEGPOSITIONPATH,
        parentPath: safePathPrefix + BELEGPOSITIONPATH,
        render: (renderProps) => <BelegpositionDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegpositionenBreadcrumb {...createProps} />,
            <BelegpositionBreadcrumb {...createProps} />,
        ],
    },
    {
        path: safePathPrefix + BELEGPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <BelegView {...renderProps} />}
                left={() => <BelegeNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: safePathPrefix + BELEGPATH,
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <BelegDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: safePathPrefix + "/beleg/:belegId/adresse",
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <BelegEmpfaengeradresseView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegEmpfaengeradresseBreadcrumb {...createProps} />
        ],
    },
    {
        exact: true,
        path: safePathPrefix + "/beleg/:belegId/texte",
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <BelegTexteView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegTexteBreadcrumb {...createProps} />
        ],
    },
    {
        exact: true,
        path: safePathPrefix + "/beleg/:belegId/belegpositionen",
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <BelegpositionenView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegpositionenBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: safePathPrefix + "/beleg/:belegId/zahlungen",
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <ZahlungenView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <ZahlungenBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: safePathPrefix + "/beleg/:belegId/belegdruck/:blobId/:modus",
        parentPath: safePathPrefix + BELEGPATH,
        render: (renderProps) => <BelegdruckView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <BelegeBreadcrumb {...createProps} />,
            <BelegBreadcrumb {...createProps} />,
            <BelegdruckBreadcrumb {...createProps} />,
        ],
    }];
}

export const belegeRouterDefintions: Array<AppRouterDefinition> = [
    ...createBelegeRouterDefinitions(undefined, (createProps) => []),
    {
        path: "/stornobedingungen",
        render: (renderProps) => <StornobedingungDefinitionenView {...renderProps} />,
        createBreadcrumbs: () => [<StornobedingungDefinitionenBreadcrumb />],
    },
    {
        path: STORNOBEDINGUNGDEFINITIONPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <StornobedingungDefinitionView {...renderProps} />}
                left={() => <StornobedingungDefinitionenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            <StornobedingungDefinitionenBreadcrumb />,
            <StornobedingungDefinitionBreadcrumb {...createProps} />],
    },
    {
        exact: true,
        path: STORNOBEDINGUNGDEFINITIONPATH,
        parentPath: STORNOBEDINGUNGDEFINITIONPATH,
        render: (renderProps) => <StornobedingungDefinitionDetailsView {...renderProps}/>,
        createBreadcrumbs: (createProps) => [
            <StornobedingungDefinitionenBreadcrumb />,
            <StornobedingungDefinitionBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: STORNOBEDINGUNGDEFINITIONPATH + "/bedingungen",
        parentPath: STORNOBEDINGUNGDEFINITIONPATH,
        render: (renderProps) => <StornobedingungenView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            <StornobedingungDefinitionenBreadcrumb />,
            <StornobedingungDefinitionBreadcrumb {...createProps} />,
            <StornobedingungenBreadcrumb {...createProps} />],
    },
    {
        path: STORNOBEDINGUNGPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <StornobedingungView {...renderProps} />}
                left={() => <StornobedingungenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            <StornobedingungDefinitionenBreadcrumb />,
            <StornobedingungDefinitionBreadcrumb {...createProps} />,
            <StornobedingungenBreadcrumb {...createProps} />,
            <StornobedingungBreadcrumb {...createProps} />]
    },
    {
        exact: true,
        path: STORNOBEDINGUNGPATH,
        parentPath: STORNOBEDINGUNGPATH,
        render: (renderProps) => <StornobedingungDetailsView {...renderProps}/>,
        createBreadcrumbs: (createProps) => [
            <StornobedingungDefinitionenBreadcrumb />,
            <StornobedingungDefinitionBreadcrumb {...createProps} />,
            <StornobedingungenBreadcrumb {...createProps} />,
            <StornobedingungBreadcrumb {...createProps} />,
        ],
    },
    {
        path: "/belegposition/:belegpositionId",
        render: (renderProps) => <BelegpositionViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/nummernkreise",
        render: (renderProps) => <NummernkreiseView {...renderProps} />,
        createBreadcrumbs: () => [<NummernkreiseBreadcrumb />],
    },
    {
        path: NUMMERNKREISPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <NummernkreisView {...renderProps} />}
                left={() => <NummernkreiseNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            <NummernkreiseBreadcrumb />,
            <NummernkreisBreadcrumb nummernkreisId={createProps.nummernkreisId} />,
        ],
    },
    {
        exact: true,
        path: NUMMERNKREISPATH,
        parentPath: NUMMERNKREISPATH,
        render: (renderProps) => <NummernkreisDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            <NummernkreiseBreadcrumb />,
            <NummernkreisBreadcrumb nummernkreisId={createProps.nummernkreisId} />,
        ],
    },
    {
        path: "/fibuexporte",
        render: (renderProps) => <FibuExporteView {...renderProps} />,
        createBreadcrumbs: () => [
            <FibuExporteBreadcrumb />
        ],
    },
    {
        path: FIBUEXPORTPATH,
        render: (renderProps) => (
            <VertialSplit
                right={() => <FibuExportView {...renderProps} />}
                left={() => <FibuExporteNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps) => [
            <FibuExporteBreadcrumb />,
            <FibuExportBreadcrumb fibuExportId={createProps.fibuExportId} />
        ],
    },
    {
        exact: true,
        path: FIBUEXPORTPATH,
        parentPath: FIBUEXPORTPATH,
        render: (renderProps) => <FibuExportDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            <FibuExporteBreadcrumb />,
            <FibuExportBreadcrumb fibuExportId={createProps.fibuExportId} />
        ],
    },
    {
        path: "/belegdruckSupport",
        render: (renderProps) => <BelegdruckSupportView {...renderProps} />,
        createBreadcrumbs: () => []
    },
    {
        path: "/stripeAnfechtung/:anfechtungId",
        render: (renderProps) => <AnfechtungViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: "/fibuexportdownload/:blobId",
        render: (renderProps) => <FibuExportDownloadRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/fibuExportEinstellungen",
        render: (renderProps) => (<FibuExportEinstellungenView {...renderProps} />),
        createBreadcrumbs: () => [<FibuExportEinstellungenBreadcrumb />],
    },
    {
        exact: true,
        path: "/fibuExportEinstellungen",
        parentPath: "/fibuExportEinstellungen",
        render: (renderProps) => <FibuExportEinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<FibuExportEinstellungenBreadcrumb />],
    },
    {
        exact: true,
        path: `/zahlungen`,
        render: props => <ZahlungenView {...props} />,
        createBreadcrumbs: props => [
            <ZahlungenBreadcrumb {...props} />,
        ],
    },
];
